import { Table, Flex } from "antd";
import React, { useEffect, useState } from "react";

const UATimesTable = ({ data = [], selectedTab }) => {
  
  const [dataDropoff, setDataDropoff] = useState([]);
  const [dataPickup, setDataPickup] = useState([]);

  // Adjusting for Dropoff times
  useEffect(() => {
    if (data?.length) {
      const formattedDropoffData = data.map((item, index) => ({
        key: String(index + 1), // Unique key for each row
        service: item.serviceType, // Service name (e.g., "Intra-U.S Bulk")
        usDomesticScreened: item.screenedTime || "N/A", // US Domestic Screened
        usDomesticUnscreened: item.unScreenedTime || "N/A", // US Domestic Unscreened
        internationalScreened: item.screenedTime || "N/A", // International Screened
        internationalUnscreened: item.unScreenedTime || "N/A", // International Unscreened
      }));
      setDataDropoff(formattedDropoffData);
    }
  }, [data]);

  // Adjusting for Pickup times
  useEffect(() => {
    if (data?.length) {
      const formattedPickupData = data.map((item, index) => ({
        key: String(index + 1), // Unique key for each row
        service: item.serviceType, // Service name (e.g., "Intra-U.S Bulk")
        usDomestic: item.time || "N/A", // Pickup time for US Domestic
        international: item.time || "N/A", // Pickup time for International
      }));
      setDataPickup(formattedPickupData);
    }
  }, [data]);

  // Dropoff columns
  const columnsDropoff = [
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "US Domestic",
      children: [
        {
          title: "Screened",
          dataIndex: "usDomesticScreened",
          key: "usDomesticScreened",
          width: 110,
        },
        {
          title: "Unscreened",
          dataIndex: "usDomesticUnscreened",
          key: "usDomesticUnscreened",
          width: 110,
        },
      ],
    },
    {
      title: "International",
      children: [
        {
          title: "Screened",
          dataIndex: "internationalScreened",
          key: "internationalScreened",
          width: 110,
        },
        {
          title: "Unscreened",
          dataIndex: "internationalUnscreened",
          key: "internationalUnscreened",
          width: 110,
        },
      ],
    },
  ];

  // Pickup columns
  const columnsPickup = [
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "US Domestic",
      dataIndex: "usDomestic",
      key: "usDomestic",
    },
    {
      title: "International",
      dataIndex: "international",
      key: "international",
    },
  ];

  return (
    <Flex vertical gap={12}>
      {selectedTab === "dropoff" ? (
        <Table
          columns={columnsDropoff}
          dataSource={dataDropoff}
          pagination={false}
          bordered
          className="zl-custom-times-table"
        />
      ) : (
        <Table
          columns={columnsPickup}
          dataSource={dataPickup}
          pagination={false}
          bordered
          className="zl-custom-times-table"
        />
      )}
    </Flex>
  );
};

export default UATimesTable;
